import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Form,
    Input,
    Space,
    Upload,
    Table
} from 'antd'
import { InboxOutlined, ProductOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { formatDate, validateSpaces } from '../../Utils/Common';
import { SeeAttachment } from '../../Components/SeeAttachment';

const { Item } = Form;

const AddEditOwner = () => {
    const { id } = useParams();
    const [addForm] = Form.useForm();
    const [newAttachment, setNewAttachment] = useState([]);
    const [attachmentsData, setAttachmentsData] = useState([]);
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false);
    const [ownerId, setOwnerId] = useState('');
    const { callPost, loading} = usePostRequest(()=>{
      addForm.resetFields();
      navigate('/owner')
    });

    const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

    async function fetchOwnerData() {
      setIsLoading(true)
      const response = await UseGetRequest("owners/get", {owner_id: id});
      if (response?.data) {
        const owner_data = response?.data?.data[0]
        let attachment = owner_data?.attachments?.map((file) => ({
          ...file,
          link: (
            <SeeAttachment
              attachments={[
                { file_url: file.file_url, file_name: file.file_name },
              ]}
            />
          ),
        })) 
        setNewAttachment(attachment)
        setAttachmentsData(fileUrlFormat(owner_data?.attachments))
        setOwnerId(owner_data?.id)  
  
        addForm.setFieldsValue({
          name: owner_data?.name,
          address: owner_data?.address,
          contact_no: owner_data?.contact_no,
          email: owner_data?.email,
          account_name: owner_data?.account_name,
          bank_name: owner_data?.bank_name,
          bank_number: owner_data?.bank_number,
          other_contact_email: owner_data?.other_contact_email || '',
        });
      } else {
        addForm.resetFields();
      }
  
      setIsLoading(false);
    }

    const handleAddOk = () => {
      addForm.validateFields().then(values => {
        const addData = {
          name: values.name,
          address: values.address,
          contact_no: values.contact_no,
          email: values.email,
          account_name: values.account_name,
          bank_name: values.bank_name,
          bank_number: values.bank_number,
          other_contact_email: values.other_contact_email || '',
        };
  
        const file = attachmentsData.map((file) => {
          return file.originFileObj;
        });
  
        var finalValues = Object.entries({...addData, attachments: file}).map(([key, value]) => ({
          key,
          value,
        }));
  
        callPost(
          "owners/create", 
          finalValues,
          true
        );
      }).catch(errorInfo => {
        toast.error('Validation Failed:', errorInfo);
      });
    };
    const handleEditOk = () => {
        addForm.validateFields()
        .then(values => {
          const resetData = {
            owner_id: ownerId,
            name: values.name,
            address: values.address,
            contact_no: values.contact_no,
            email: values.email,
            account_name: values.account_name,
            bank_name: values.bank_name,
            bank_number: values.bank_number,
            other_contact_email: values.other_contact_email || '',
          };
    
          const file = attachmentsData.map((data) => {
            if(data.originFileObj){
              return data.originFileObj;
            }
            return data
          });
    
          const attch_ids = attachmentsData.map((data) => {
            if(data.id){
              return data.id;
            }
            return ""
          });
    
          
          var finalValues = Object.entries({...resetData, attachments: file, attachment_ids: attch_ids}).map(([key, value]) => ({
              key,
              value,
          }));
    
          callPost(
            "owners/update",
            finalValues,
            true
          );
        })
        .catch(errorInfo => {
          toast.error('Validation Failed:', errorInfo);
        });
    };  
    
    const handleDeleteAttachment = (file) => {
      const updatedAttachments = attachmentsData.filter(item => item !== file);
      setAttachmentsData(updatedAttachments);
    };

    const columns2 = [
      {
        title: 'Date Added',
        dataIndex: 'added_on',
        key: 'added_on',
        width: '30%',
        render: (amount) => formatDate(amount),
      },
      {
        title: 'Attachments',
        dataIndex: 'link',
        key: 'link',
      },
    ]; 

    const fileUrlFormat = (files) => {
      if(files){
        return files?.map(file => ({
          uid: file.id,
          id: file.id,
          name: file.file_name,
          status: "done",
          url: file.file_url,
          fileType: file.file_type
        }));
      }
    };

  
    const validateContactNumber = (_, value) => {
      if (!value) {
        return Promise.resolve();
      }
  
      const isNumber = /^\d+$/.test(value);
      if (!isNumber) {
        return Promise.reject('Invalid Contact Number');
      }
      return Promise.resolve();
    }; 
  
    const normFile = (e) => {
  
      if (Array.isArray(e)) {
          setAttachmentsData(e)
      }
      setAttachmentsData(e?.fileList)
      
    };
    
    useEffect(() => {
      if(id){
        fetchOwnerData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    return (
      <Layout className='page'>
        <Navbar/>
        <Layout className='content-container overflow-y p-4'>
          <Row>
            <Col span={24} className='header-container'>
              { id ? "EDIT OWNER" : "ADD OWNER"}
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form 
                form={addForm} 
                layout="vertical"
              >
                <Row className='responsive-inline responsive-width'>
                  <Col span={6} className='p-2'>
                    <Item
                        label="Owner Name"
                        name="name"
                        className='p-0 m-0'
                        rules={[
                          { required: true, message: 'Please enter your Owner Name!' },
                          { validator: validateSpaces }
                        ]}
                    >
                        <Input/>
                    </Item>
                </Col>
                <Col span={6} className='p-2'>
                  <Item
                    label="Address"
                    name="address"
                    rules={
                      [
                        { required: true, message: 'Please enter your Owner Address!' },
                        { validator: validateSpaces }
                      ]
                    }
                  >
                    <Input/>
                  </Item>
                </Col>
                <Col span={6} className='p-2'>
                  <Item
                    label="Contact Number"
                    name="contact_no"
                    rules={
                      [
                        { 
                          required: true, 
                          message: 'Please enter your Contact Number!' 
                        },
                        {
                          validator: validateContactNumber
                        },
                        { 
                          validator: validateSpaces 
                        }
                      ]
                    }
                    >
                      <Input/>
                    </Item>
                </Col>
                <Col span={6} className='p-2'>
                  <Item
                    label="Email"
                    name="email"
                    rules={
                      [
                        { 
                          required: true, message: 'Please enter your Owner Email!' 
                        },
                        { 
                          type: 'email', message: 'Please enter a valid email address!' 
                        },
                        { 
                          validator: validateSpaces 
                        }
                      ]
                    }
                    >
                      <Input />
                  </Item>
                </Col>
              </Row>
              <Row className='responsive-inline responsive-width'>
                <Col span={6} className='p-2'>
                  <Item
                    label="Account Name"
                    name="account_name"
                    className='p-0 m-0'
                    rules={[
                      { required: true, message: 'Please enter your Owner Name!' },
                      { validator: validateSpaces }
                    ]}
                  >
                    <Input/>
                  </Item>
                </Col>
                <Col span={6} className='p-2'>
                  <Item
                    label="Bank Name"
                    name="bank_name"
                    rules={
                      [
                        { required: true, message: 'Please enter your Owner Address!' },
                        { validator: validateSpaces }
                      ]
                    }
                  >
                    <Input/>
                  </Item>
                </Col>
                <Col span={6} className='p-2'>
                  <Item
                    label="Bank Number"
                    name="bank_number"
                    rules={
                      [
                        { 
                          required: true, 
                          message: 'Please enter your Contact Number!' 
                        },
                        { 
                          validator: validateSpaces 
                        }
                      ]
                    }
                  >
                    <Input/>
                  </Item>
                </Col>
                <Col span={6} className='p-2'>
                  <Item
                    label="Other Contact Info"
                    name="other_contact_email"                
                  >
                    <Input/>
                  </Item>
                </Col>
              </Row>
              {
                id && (
                  <Row className='my-5'>
                    <Col span={24}>
                      <Table 
                        columns={columns2} 
                        dataSource={newAttachment} 
                        pagination={false}
                        loading={{
                          indicator: customSpinner,
                          spinning: isLoading,
                        }}
                      />
                    </Col>
                  </Row>
                )
              }
              <Row className='responsive-inline responsive-width'>
                <Col span={24} className='p-2'>
                  {/* <Item
                    label="Attachment"
                  >
                    <Item name="attachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                      <Upload.Dragger name="files" action="/upload.do">
                      <p className="ant-upload-drag-icon">
                          <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">Click or drag file to this area to upload</p>
                      <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                      </Upload.Dragger>
                    </Item>
                  </Item> */}
                  <Item 
                    label="Attachment"
                    name="attachments" 
                    // valuePropName="fileList" 
                    getValueFromEvent={normFile} 
                    noStyle
                  >
                    <Upload.Dragger 
                      multiple
                      name="files" 
                      // action="/upload.do"
                      fileList={attachmentsData}               
                      beforeUpload={() => false}
                      onRemove={handleDeleteAttachment}
                    >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                    <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                    </Upload.Dragger>
                  </Item>
                </Col>
              </Row>
              <Row className='btn-footer'>
                <Space className='p-2'>
                  <Button
                    onClick={() => navigate('/owner')}
                    className='cancel-color btn-header'
                    >
                      Cancel
                  </Button>
                  {
                    id ? (
                      <Button
                        onClick={handleEditOk}
                        loading={loading}
                        type='primary'
                        className='button-color btn-header'
                      >
                          Save
                      </Button>
                    ) : (
                      <Button
                        onClick={handleAddOk}
                        loading={loading}
                        type='primary'
                        className='button-color btn-header'
                      >
                        Submit
                      </Button>
                    )
                  }
                </Space>
              </Row>
            </Form>
          </Col>
        </Row>
      </Layout>
    </Layout>
  )
}

export default AddEditOwner
